var _rect, _circle, _rect2, _rect3, _circle2, _rect4, _rect5, _circle3, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecentActivitiesNotFound = function SvgRecentActivitiesNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 160,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 41.176,
    x: 11,
    y: 110.177,
    fill: "#F5F8FC",
    stroke: "#D6E5F2",
    strokeWidth: 1.5,
    rx: 11.765
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.354,
    cy: 130.471,
    r: 5.588,
    fill: "#fff",
    stroke: "#D6E5F2",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 93.529,
    height: 11.177,
    x: 39.234,
    y: 124.883,
    fill: "url(#recent_activities_not_found_svg__a)",
    stroke: "#D6E5F2",
    strokeWidth: 1.5,
    rx: 5.588
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 41.176,
    x: 11,
    y: 59.588,
    fill: "#F5F8FC",
    stroke: "#D6E5F2",
    strokeWidth: 1.5,
    rx: 11.765
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.354,
    cy: 79.883,
    r: 5.588,
    fill: "#fff",
    stroke: "#D6E5F2",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 93.529,
    height: 11.177,
    x: 39.234,
    y: 74.294,
    fill: "url(#recent_activities_not_found_svg__b)",
    stroke: "#D6E5F2",
    strokeWidth: 1.5,
    rx: 5.588
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 41.176,
    x: 11,
    y: 9,
    fill: "#F5F8FC",
    stroke: "#D6E5F2",
    strokeWidth: 1.5,
    rx: 11.765
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.354,
    cy: 29.294,
    r: 5.588,
    fill: "#fff",
    stroke: "#D6E5F2",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 93.529,
    height: 11.177,
    x: 39.234,
    y: 23.706,
    fill: "url(#recent_activities_not_found_svg__c)",
    stroke: "#D6E5F2",
    strokeWidth: 1.5,
    rx: 5.588
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "recent_activities_not_found_svg__a",
    x1: 40.33,
    x2: 132.762,
    y1: 129.85,
    y2: 130.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "recent_activities_not_found_svg__b",
    x1: 40.33,
    x2: 132.762,
    y1: 79.261,
    y2: 80.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "recent_activities_not_found_svg__c",
    x1: 40.33,
    x2: 132.762,
    y1: 28.673,
    y2: 29.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgRecentActivitiesNotFound;